import TcTable from '../TcTable';

export default function PhysicalCheckoutView() {
  return <TcTable />;
}
